import React, { createRef, useEffect, useState } from "react";
import './LotReport.css';
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../../components/Table/Table";
import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import getToken, { redirectToLogin } from "../../getToken";
import authStore from "../../../store/authStore";
import { DateRange } from "react-date-range";
import { format, parseISO} from "date-fns";
import calenderIcon from "../../../images/icons/calendar.png";
import * as XLSX from "xlsx";
import excelIcon from "../../../images/icons/download.png";
import { message } from "antd";

const LotReport = () => {
    const refLotReportTable = createRef();
    const [keyword, setKeyword] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [showDatePicker, setShowDatePicker] = useState(false);

    const [dateRange, setDateRange] = useState({
        startDate: new Date(),
        endDate: new Date()
    });

    const brandId = authStore((state) => state.auth?.brandId);

    const [reportList, setReportList] = useState({
        isLoading: true,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramReport, setParamReport] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd"),
    });

    const retrieveReportList = async (value = paramReport) => {
        const request = {
            ...value,
            keyword: value.keyword || "",
            startDate: format(startDate, "yyyy-MM-dd"),
            endDate: format(endDate, "yyyy-MM-dd")
        };

        api.post("Admin/GetLotReport", request, getToken())
            .then((result) => {

                apiUtil.parseResult(
                    result,
                    (response) => {
                        if (response.data.code === 401) {
                            message.warning(response.data.message);
                            redirectToLogin();
                        }
                        else if (response.data.code === 200) {
                            setReportList({
                                isLoading: false,
                                limit: 10,
                                data: response.data.data.data || [],
                                total: response.data.data.totalRecords,
                                page: response.data.data.paging,
                            });

                        }
                        else {
                            setReportList({
                                data: [],
                                total: 0,
                                page: 0,
                                limit: 0,
                                isLoading: false,
                            });

                        }

                    },
                    (error) => {
                        console.log(error);
                    }
                );
            });
    };

    const exportToExcel = async () => {
        try {
            const request = {
                ...paramReport,
                keyword,
                currentPage: 1,
                rowLimit: 100000,
                startDate: format(startDate, "yyyy-MM-dd"),
                endDate: format(endDate, "yyyy-MM-dd"),
            };

            const result = await api.post("Admin/GetLotReport", request, getToken());

            apiUtil.parseResult(result, (response) => {

                const data = response.data.data.data || [];

                if (data.length === 0) {
                    message.warning("No data available to export");
                    return;
                }

                const lotSummary = data.map((row, index) => ({
                    No: index + 1,
                    Expo: row.expoName,
                    Lot: row.lotName,
                    Service: row.serviceName,
                    Marker: row.markerName,
                    Rate: row.rate,
                    Weight: row.weight,
                    Price: row.price,
                    Percent: row.percentage ? row.percentage + "%" : "",
                    SaleAmount: row.saleAmount,
                    ServiceFee: row.serviceFee,
                    TotalPrice: row.totalPrice,
                    Description: row.description
                }));

                const carryFee = [];
                data.forEach((lot) => {
                    if (lot.carryFeeList && lot.carryFeeList.length > 0) {
                        lot.carryFeeList.forEach((item) => {
                            carryFee.push({
                                Date: format(parseISO(item.date), 'dd-MM-yy'),
                                Name: "ကယ်ရီခ",
                                Lot: lot.lotName,
                                Rate: item.rate,
                                Weight: item.weight,
                                Price: item.totalPrice.toLocaleString(),
                                Note: item.description
                            });
                        });

                    }
                });

                const protectionPrice = [];
                data.forEach((lot) => {
                    if (lot.protectionPriceList && lot.protectionPriceList.length > 0) {
                        lot.protectionPriceList.forEach((item) => {
                            protectionPrice.push({
                                Name: "ကာစျေး",
                                Lot: lot.lotName,
                                ServiceName: item.serviceName,
                                Rate: item.rate,
                                Price: item.price,
                                Percent: item.percent + "%",
                                Amount: item.amount,
                                Note: item.description
                            });
                        });

                    }
                });

                const refundPrice = [];

                data.forEach((lot) => {
                    if (lot.refundPriceList && lot.refundPriceList.length > 0) {

                        lot.refundPriceList.forEach((item) => {
                            refundPrice.push({
                                Name: "လျော်ကြေး",
                                Lot: lot.lotName,
                                Price: item.price,
                                Percent: item.percent + "%",
                                Amount: item.amount,
                                Note: item.description
                            });
                        });

                    }
                });

                const colorEnhancedFee = [];
                data.forEach((lot) => {
                    if (lot.colorEnhancedFeeList && lot.colorEnhancedFeeList.length > 0) {
                        lot.colorEnhancedFeeList.forEach((item) => {
                            colorEnhancedFee.push({
                                Lot: lot.lotName,
                                Note: item.description,
                                Amount: item.price.toLocaleString(),
                            });
                        });
                    }
                });

                const deposit = [];
                data.forEach((lot) => {
                    if (lot.depositList && lot.depositList.length > 0) {
                        lot.depositList.forEach((item) => {
                            deposit.push({
                                Lot: lot.lotName,
                                Note: item.description,
                                Amount: item.price.toLocaleString(),
                            });
                        });

                    }
                });

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(
                    wb,
                    XLSX.utils.json_to_sheet(lotSummary),
                    "Lot Summary"
                );

                if (carryFee.length > 0) {
                    XLSX.utils.book_append_sheet(
                        wb,
                        XLSX.utils.json_to_sheet(carryFee),
                        "Carry Fee"
                    );
                }

                if (protectionPrice.length > 0) {
                    XLSX.utils.book_append_sheet(
                        wb,
                        XLSX.utils.json_to_sheet(protectionPrice),
                        "Protection Price"
                    );
                }

                if (refundPrice.length > 0) {
                    XLSX.utils.book_append_sheet(
                        wb,
                        XLSX.utils.json_to_sheet(refundPrice),
                        "Refund Price"
                    );
                }

                if (colorEnhancedFee.length > 0) {
                    XLSX.utils.book_append_sheet(
                        wb,
                        XLSX.utils.json_to_sheet(colorEnhancedFee),
                        "Color Enhanced Fee"
                    );
                }

                if (deposit.length > 0) {
                    XLSX.utils.book_append_sheet(
                        wb,
                        XLSX.utils.json_to_sheet(deposit),
                        "Deposit"
                    );
                }

                XLSX.writeFile(
                    wb,
                    "ရောင်းပြီး ကုန်စည်စာရင်း.xlsx"
                );
            });

        } catch (error) {
            console.error("Error exporting Lot Report:", error);
        }
    };

    useEffect(() => {

        retrieveReportList({
            ...paramReport,
            keyword
        });

    }, [
        paramReport.currentPage,
        startDate,
        endDate
    ]);




    const handleDateRangeChange = (ranges) => {

        const { startDate, endDate } = ranges.selection;

        setStartDate(startDate);
        setEndDate(endDate);

        setDateRange({
            startDate,
            endDate
        });


        retrieveReportList();

    };



    const handleInputClick = () => {

        setShowDatePicker(
            previous => !previous
        );

    };



    useEffect(() => {

        const handleOutsideClick = (e) => {

            if (!e.target.closest(".date-input-container")) {

                setShowDatePicker(false);

            }

        };


        document.addEventListener(
            "click",
            handleOutsideClick
        );


        return () => {

            document.removeEventListener(
                "click",
                handleOutsideClick
            );
        };
    }, []);

    return (
        <>
            <div className="Actions space_between">
                <h6 className="title_text mt-2">
                    Lot Report
                </h6>
                <div className="d-flex justify-content-end gap-16 align-items-center">
                    <button
                        className="export-button"
                        onClick={exportToExcel}
                    >
                        <img
                            src={excelIcon}
                            className="icon"
                        />
                        Export to Excel
                    </button>

                    <div className="date-input-container">
                        <input
                            type="text"
                            className="inputBox input-right-side_text"
                            value={
                                `${format(dateRange.startDate, "yyyy MMM dd")} - ${format(dateRange.endDate, "yyyy MMM dd")}`
                            }
                            readOnly
                            onClick={handleInputClick}
                        />
                        <img
                            src={calenderIcon}
                            className="iconDate"
                            onClick={handleInputClick}
                        />
                        {
                            showDatePicker &&
                            <div className="input-dateRange">
                                <DateRange
                                    showDateDisplay={false}
                                    ranges={[
                                        {
                                            startDate,
                                            endDate,
                                            key: "selection"
                                        }
                                    ]}
                                    onChange={handleDateRangeChange}
                                />
                            </div>
                        }
                    </div>

                    <CustomSearchBar
                        value={keyword}
                        setValue={setKeyword}
                        onSearch={(value) => {
                            setParamReport((prev) => ({
                                ...prev,
                                keyword: value || "",
                                currentPage: 1
                            }));
                        }}  
                    />
                </div>
            </div>

            <div className="table_container report_table">
                <Table
                    ref={refLotReportTable}
                    maxBodyHeight={reportList.limit * 100}
                    isLoading={reportList.isLoading}
                    grouping={reportList.grouping}
                    limit={reportList.limit}
                    page={reportList.page}
                    total={reportList.total}
                    data={reportList.data}
                    onPageChange={(page) => {
                        setParamReport({
                            ...paramReport,
                            currentPage: page
                        });
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1,
                            width: "80px"
                        },
                        {
                            title: "Expo",
                            field: "expoName"
                        },
                        {
                            title: "Lot",
                            field: "lotName"
                        },
                        {
                            title: "Service",
                            field: "serviceName"
                        },
                        {
                            title: "Marker",
                            field: "markerName"
                        },
                        {
                            title: "Rate",
                            field: "rate"
                        },

                        {
                            title: "Weight",
                            field: "weight"
                        },

                        {
                            title: "Price",
                            field: "price"
                        },

                        {
                            title: "Sale Amount",
                            render: (row) =>
                                Number(row.saleAmount)
                                    .toLocaleString()
                        },
                        {
                            title: "Total Price",
                            render: (row) =>
                                Number(row.totalPrice)
                                    .toLocaleString()
                        }
                    ]}
                />
            </div>
        </>
    );
};

export default LotReport;